/* eslint-disable react/prop-types */
/**
 *
 * ModuleBaseRoute
 *
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Alert, AlertTitle, Paper, Typography } from '@mui/material';
import ErrorBoundary from '../ErrorBoundary';
import {
  makeSelectHasSupporterModule,
  makeSelectHasVolunteerModule,
  selectHasGlobalDashboard,
  selectHasNotificationModule,
  selectHasTeamGroupModule,
} from '../../managers/AuthManager/selectors';

function NoAccessText() {
  return (
    <Paper elevation={2}>
      <Alert severity="error">
        <AlertTitle>Module disabled</AlertTitle>
        <Typography>You don&apos;t have access to this page.</Typography>
      </Alert>
    </Paper>
  );
}

export function ModuleBasedRoute({ module }) {
  const hasSupporterModule = useSelector(makeSelectHasSupporterModule);
  const hasVolunteerModule = useSelector(makeSelectHasVolunteerModule);
  const hasTeamGroupModule = useSelector(selectHasTeamGroupModule);
  const hasNotification = useSelector(selectHasNotificationModule);
  const hasDashboard = useSelector(selectHasGlobalDashboard);

  if (
    (module === 'Volunteer' && !hasVolunteerModule) ||
    (module === 'Supporter' && !hasSupporterModule) ||
    (module === 'TeamGroup' && !hasTeamGroupModule) ||
    (module === 'Notification' && !hasNotification) ||
    (module === 'GlobalDashboard' && !hasDashboard)
  ) {
    return <NoAccessText />;
  }

  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  );
}

export default ModuleBasedRoute;
